/* =========================================================================
   schema-dedupe.js — colisão de rich snippet na PDP
   =========================================================================

   MITIGAÇÃO, NÃO CURA.

   Medido em 07/08/2026 na PDP real (HTML cru, sem JS):

     ld+json #1  Organization   app SEO Expert Pro   (app embed evm-seo)
     ld+json #2  WebSite        app SEO Expert Pro
     ld+json #3  Product        app SEO Expert Pro   offers+aggregateRating+review+image
     ld+json #4  Product        TEMA                 offers+image, sem aggregateRating

   Dois Product na mesma URL fazem o Google descartar o rich result inteiro.
   Este script roda cedo, pontua todos os blocos cujo nó raiz é um Product,
   mantém o MAIS COMPLETO (offers > aggregateRating > image > identificadores)
   e remove os Product duplicados do DOM.

   Por que é mitigação: o Google também lê o HTML servido antes de renderizar.
   A cura de verdade é não emitir o segundo Product na origem —
   snippets/schema-product.liquid, `assign emit_theme_product = false`.
   Essa mudança está documentada lá e aguarda aprovação; enquanto isso, este
   script segura o estrago no DOM renderizado.

   Regras respeitadas: nunca cria um Product novo, nunca inventa
   aggregateRating, nunca toca em dado de avaliação. Só descarta duplicata.
   Vanilla puro — sem jQuery.
   ========================================================================= */

(function () {
  'use strict';

  var STATE = (window.__schemaDedupe = window.__schemaDedupe || {
    runs: 0,
    kept: null,
    removed: []
  });

  var DEBUG =
    /[?&]schema_debug=1/.test(window.location.search) ||
    !!(window.Shopify && window.Shopify.designMode);

  function isProductType(type) {
    if (!type) return false;
    if (typeof type === 'string') return type.toLowerCase() === 'product';
    if (Array.isArray(type)) {
      for (var i = 0; i < type.length; i++) {
        if (typeof type[i] === 'string' && type[i].toLowerCase() === 'product') return true;
      }
    }
    return false;
  }

  function parse(node) {
    var raw = node.textContent;
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function has(obj, key) {
    var v = obj[key];
    if (v === undefined || v === null || v === '') return false;
    if (Array.isArray(v)) return v.length > 0;
    if (typeof v === 'object') return Object.keys(v).length > 0;
    return true;
  }

  /* Completude: quem tiver mais sinal de rich result vence.
     offers e aggregateRating são o que o Google efetivamente usa no snippet. */
  function score(data, node) {
    var s = 0;
    if (has(data, 'offers')) s += 40;
    if (has(data, 'aggregateRating')) s += 40;
    if (has(data, 'image')) s += 20;
    if (has(data, 'review')) s += 10;
    if (has(data, 'brand')) s += 5;
    if (has(data, 'description')) s += 5;
    ['sku', 'gtin', 'gtin8', 'gtin12', 'gtin13', 'gtin14', 'mpn', 'productId'].forEach(function (k) {
      if (has(data, k)) s += 3;
    });
    /* desempate estável: bloco mais longo costuma ser o mais descritivo */
    s += Math.min((node.textContent || '').length / 10000, 2);
    return s;
  }

  function run() {
    STATE.runs++;

    var nodes = document.querySelectorAll('script[type="application/ld+json"]');
    var products = [];

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.hasAttribute('data-schema-deduped')) continue;
      var data = parse(node);
      /* só mexe em bloco cuja RAIZ é um Product isolado.
         @graph, arrays e blocos mistos ficam intocados de propósito —
         remover um deles derrubaria schema que não está em conflito. */
      if (!data || typeof data !== 'object' || Array.isArray(data)) continue;
      if (data['@graph']) continue;
      if (!isProductType(data['@type'])) continue;
      products.push({ node: node, data: data, score: score(data, node) });
    }

    if (products.length < 2) {
      if (DEBUG) {
        console.info('[schema-dedupe] ' + products.length + ' Product na página, nada a fazer.');
      }
      return;
    }

    products.sort(function (a, b) {
      return b.score - a.score;
    });

    var winner = products[0];
    STATE.kept = {
      score: winner.score,
      source: winner.node.getAttribute('data-schema-source') || 'app',
      keys: Object.keys(winner.data)
    };

    for (var j = 1; j < products.length; j++) {
      var loser = products[j];
      STATE.removed.push({
        score: loser.score,
        source: loser.node.getAttribute('data-schema-source') || 'app',
        keys: Object.keys(loser.data)
      });
      loser.node.setAttribute('data-schema-deduped', 'removed');
      if (loser.node.parentNode) loser.node.parentNode.removeChild(loser.node);
    }

    winner.node.setAttribute('data-schema-deduped', 'kept');

    if (DEBUG) {
      console.info(
        '[schema-dedupe] mantido Product (' +
          STATE.kept.source +
          ', score ' +
          Math.round(winner.score) +
          '); removidos ' +
          (products.length - 1) +
          '.',
        STATE
      );
    }
  }

  run();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  }
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);

  /* Alguns apps só injetam o ld+json depois. Observa por um tempo curto
     e desliga sozinho — nada de observer vitalício na PDP. */
  if (typeof MutationObserver === 'function') {
    var pending = null;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var el = added[j];
          if (el.nodeType === 1 && el.tagName === 'SCRIPT' && el.type === 'application/ld+json') {
            if (pending) clearTimeout(pending);
            pending = setTimeout(run, 120);
            return;
          }
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      observer.disconnect();
      if (pending) clearTimeout(pending);
      run();
    }, 8000);
  }
})();
